
import React from "react";

const AboutPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-6">About PΛREΛGON</h1>
      <p className="text-lg leading-relaxed">
      PΛREΛGON was created with one goal in mind: to bring a fresh perspective to streetwear sneakers. We&apos;re about more than just shoes we&apos;re about telling a story with every step.
      </p>
      <p className="mt-6 text-lg leading-relaxed">
      Our journey started from a real place: passion for design, respect for quality, and the drive to do things our way. Every pair we make is built with a purpose: simple, clean, and made to last.      </p>
      <p className="mt-6 text-lg leading-relaxed">
      We&apos;re here to push boundaries and create a community around a brand that feels real. PΛREΛGON is for those who want to stand out without trying too hard. It&apos;s about wearing what feels right, and living your own style. </p>

      <p className="mt-6 text-lg leading-relaxed">
      Thanks for checking us out.
        </p>
    </div>
  );
};

export default AboutPage;
